module.exports = __webpack_public_path__ + "img/home_logo.cf7f00ce.png";